export enum UpcomingUpgradeStatus {
    None = 0,
    Minor = 1,
    Major = 2,
    Both = 3,
}
